import {
  BooleanQueryEntity,
  EntityQuery,
  FilterQueryEntity,
  SectionEntity,
} from '~/types/OpenSearch';

export const testIsFilter = (
  queryEntity: EntityQuery,
): queryEntity is FilterQueryEntity => queryEntity.type === 'filter';

export const testIsSection = (
  queryEntity: EntityQuery,
): queryEntity is SectionEntity => queryEntity.type === 'section';

export const testIsBooleanTextSearch = (
  queryEntity: EntityQuery,
): queryEntity is BooleanQueryEntity => queryEntity.type === 'bool_text_search';
